import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
import Swoosh from '@img/backgrounds/swoosh.svg?url';
import fonts from '@helpers/fonts';
import brand from '@helpers/brand';
import { m } from 'framer-motion';
import { verticalFadeIn } from '@helpers/animate';
import { Device, from, until } from '@helpers/media';
import { fluid } from '@helpers/fluid';
import { contentStyles } from '@helpers/typography';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
const Container = styled(SectionWrapper) `
  --siteWidth: 1920px;

  min-height: ${fluid(450, 592, Device.Mobile, Device.DesktopLarge)};
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  @media ${until(Device.Tablet)} {
    background: transparent
      linear-gradient(180deg, ${brand.primary.darkBlue}, ${brand.primary.brightBlue});
  }

  ${SectionWrapperStyles.Inner} {
    display: flex;
    justify-content: flex-end;
    flex-grow: 1;
    max-width: unset;

    padding: 0;
    padding-left: var(--sitePadding);
    padding-right: var(--sitePadding);
  }
`;
const BackgroundImage = styled.div `
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
  inset: 0;

  [data-has-content='true'] & {
    @media ${until(Device.Tablet)} {
      display: none;
    }
  }

  img {
    width: 100%;
    height: 100%;

    object-fit: cover;
    object-position: center center;
  }
`;
const Content = styled(m.div).attrs(() => ({
    variants: {
        hidden: {
            opacity: 0,
            x: 45,
        },
        visible: {
            opacity: 1,
            x: 0,
        },
    },
    transition: {
        ease: 'easeOut',
        duration: 0.5,
        delayChildren: 0.45,
        staggerChildren: 0.15,
    },
})) `
  display: flex;
  flex-direction: column;
  z-index: 1;
  width: 100%;
  position: relative;
  align-items: flex-start;
  justify-content: flex-start;
  top: 0;
  padding-top: var(--sectionSpacingTop);
  padding-bottom: var(--sectionSpacingBottom);

  @media ${from(Device.Tablet)} {
    padding-left: ${fluid(16, 25, Device.Mobile, Device.DesktopLarge)};
    max-width: 370px;

    &::after {
      content: '';
      position: absolute;
      z-index: -1;

      background-image: url(${Swoosh});
      background-size: cover;
      background-repeat: no-repeat;
      background-position: top left;

      width: 790px;
      height: 100%;
      top: 0;
      right: -49px;
    }
  }
`;
const Title = styled(m.h2).attrs(() => ({
    variants: verticalFadeIn(-15),
})) `
  ${fonts.ubuntu.regular};
  color: ${brand.primary.white};

  font-size: ${fluid(46, 48)};
  line-height: ${fluid(47, 55)};
  letter-spacing: -2px;
  margin-bottom: ${fluid(20, 30)};
  text-wrap: pretty;

  &[data-long-title='true'] {
    font-size: ${fluid(35, 40)};
    line-height: ${fluid(42, 48)};
  }
`;
const BannerContent = styled(m.div).attrs(() => ({
    variants: verticalFadeIn(-15),
})) `
  ${fonts.ubuntu.regular};
  color: ${brand.primary.white};
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 24px;
  text-wrap: pretty;

  ${contentStyles}
  white-space: pre-line;
`;
const CTAWrapper = styled(m.div).attrs(() => ({
    variants: verticalFadeIn(-15),
})) `
  &[data-variant='button'] {
    ${ButtonStyles.Container} {
      --buttonPaddingY: 8px;
      --buttonPaddingX: 12px;
    }
  }

  &[data-add-top-margin='true'] {
    margin-top: 10px;
  }

  ${ButtonStyles.Text} {
    line-height: 24px;
  }
`;
export const HeroBannerStyles = {
    Container,
    BackgroundImage,
    Content,
    Title,
    BannerContent,
    CTAWrapper,
};
